import { listTenantByUserCodeAndAppCode } from 'resfull/member/memberlist.js';
import { getAppList } from 'resfull/npgw/cms/navigation';
const state = {
    siteList: [],
    appList:[],
};

const getters = {
    siteList: state => state.siteList,
    appList: state=>state.appList,
    emailList:state => state.emailList,
};

const mutations = {
    SET_SITELIST: (state, siteList) => {
        state.siteList = siteList;
    },
    SET_APPLIST:(state,appList)=>{
        state.appList = appList;
    },
    SET_EMAILLIST:(state,emailList)=>{
        state.emailList = emailList;
    },
};

const actions = {
    async setSiteList({ commit }, info) { //2024        
        if(!info.appCode) return;
        let res = await listTenantByUserCodeAndAppCode({
            appCode: info.appCode,
            userCode: info.userCode,
            isSuper: info.isSuper
        })
        if (res.status == 200) {
            commit('SET_SITELIST', res.data);
            return res.data;
        }else{
            return false
        }


    },
    async setAppList({commit},data){
        const res = await getAppList();
        if (res.code == '200') {
            commit('SET_APPLIST', res.appList)
            return true;
        }else{
            return true;
        }
    },
    async setEmailList({ commit }, list) {//2024
        commit('SET_EMAILLIST', list);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
